<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const UpdownGameIcon = getIcon("UpdownGameIcon");
</script>

{#if typeof UpdownGameIcon === 'string'}
	<img src={UpdownGameIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof UpdownGameIcon === 'function'}
	<svelte:component this={UpdownGameIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
